import React from 'react'
import Cookies from 'universal-cookie';
import {useNavigate, useLocation } from "react-router-dom";
import UserApi from '../components/UserApi';
const Login = () => {
    let navigate = useNavigate();
    let location = useLocation();
    const cookiess = new Cookies();
    var loginlink = window.location.href;
    var loginlink2 = loginlink.split("&");
    var clearwtknques = loginlink2[0].split("?")
    var clearwtkn = clearwtknques[1].replace("wtkn=", "");
    var clearclient = loginlink2[1].replace("token=", "");
    var clearscrf = loginlink2[2].replace("csrf=", "");
    cookiess.set('wtkn', clearwtkn, { path: '/' });
    cookiess.set('client', clearclient, { path: '/' });
    cookiess.set('csrf', clearscrf, { path: '/' });
    const {
        theme,
      } = UserApi();
    navigate("/");
  return (
    <div></div>
  )
}

export default Login